import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from '../Loader'
import PersonalInformation from '../PersonalInformation'
import ProfilePicture from '../ProfilePicture'
import Sections from '../Sections'
import ProfileData from '../ProfileData'
import Overall from '../Overall'
import AspireUiIntro from '../LoginScreens/AspireUiIntro'
import _ from 'underscore'
import Tour from '../../tour/Tour'
import { markSectionVisited } from '../../actions/AspireFeedback'
import {
  expandLeftNav,
  showEditModal,
  toggleRightNav,
} from '../../actions/Edit'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { injectIntl, FormattedMessage } from 'react-intl'
import {
  sectionUnderscoreName,
  sectioNameToBackendVisitedSectioNameMapping,
  staticFeedback,
} from '../Constants/DetailedFeedbackText'
import { selectIndex } from '../../actions/DetailedFeedback'
import PageTracking from '@vmockinc/dashboard/Common/commonComps/PageTracking'
import classNames from 'classnames'
import { CircularBar } from '@vmockinc/dashboard/Common/commonComps/ProgressBar'

class DetailedFeedback extends Component {
  constructor(props) {
    super(props)
    this.timeScreenStart = 0
    this.checkVisitedSection = this.checkVisitedSection.bind(this)
    this.checkVisitedSectionDebounce = _.debounce(
      this.checkVisitedSection,
      1000,
      true
    )
    this.sendTrackingDataDebouncePageLoad = _.debounce(
      sendTrackingData,
      2000,
      true
    )

    this.sectionComponents = {
      'Personal Information': PersonalInformation,
      'Profile Picture': ProfilePicture,
      Headline: Sections,
      Summary: Sections,
      Experience: Sections,
      Education: Sections,
      Overall: Overall,
    }

    this.sectionUnderscore = {
      'Personal Information': 'personal_information',
      'Profile Picture': 'profile_picture',
      Headline: 'headline',
      Summary: 'summary',
      Experience: 'experience',
      Education: 'education',
    }

    this.state = {
      activeId: 0,
    }

    this.textMap = {
      green: this.props.intl.formatMessage({
        id: 'aspire.leftNav.profileStrengthStatusGoodJob',
        defaultMessage: 'Good Job!',
      }),
      yellow: this.props.intl.formatMessage({
        id: 'aspire.leftNav.profileStrengthStatusOnTrack',
        defaultMessage: 'On Track!',
      }),
      red: this.props.intl.formatMessage({
        id: 'aspire.leftNav.profileStrengthStatusNeedsWork',
        defaultMessage: 'Needs Work!',
      }),
    }
  }

  componentDidMount() {
    let timeScreenStart = new Date()
    this.timeScreenStart = timeScreenStart.getTime()
    this.sendTrackingDataDebouncePageLoad(
      'page_level',
      'aspire_detailed_feedback_screen',
      'load',
      'page_loaded'
    )
  }

  componentDidUpdate(prevProps, prevState) {
    let currentSectionName = this.props.ui.section
    this.checkVisitedSectionDebounce(currentSectionName)
    const { ui, selectIndex, showEditModal } = this.props
    if (['Summary', 'Education', 'Experience'].includes(currentSectionName)) {
      if ('sectionWiseText' in prevProps.ui && 'sectionWiseText' in ui) {
        if (
          _.size(
            prevProps.ui['sectionWiseText'][
              this.sectionUnderscore[currentSectionName]
            ]
          ) !==
          _.size(
            ui['sectionWiseText'][this.sectionUnderscore[currentSectionName]]
          )
        ) {
          if (currentSectionName === 'Summary') {
            showEditModal(false, 'Summary')
            selectIndex(0)
          } else {
            showEditModal(false, currentSectionName)
            if (
              _.size(
                ui['sectionWiseText'][
                  this.sectionUnderscore[currentSectionName]
                ]
              ) === 1
            ) {
              selectIndex(0)
            } else {
              selectIndex(null)
            }
          }
        }
      }
    }
  }

  componentWillUnmount() {
    let timeScreenEnd = new Date()
    let timeScreenSpent =
      (timeScreenEnd.getTime() - this.timeScreenStart) / 1000
    if (timeScreenSpent > 2) {
      let jsonObjectForTracking = {
        eventLabel: 'screen_time',
        time: timeScreenSpent,
      }
      sendTrackingData(
        'event',
        'aspire_detailed_feedback_screen',
        'time',
        JSON.stringify(jsonObjectForTracking)
      )
    }
  }

  checkVisitedSection(currentSectionName) {
    let visitedSectionModuleName =
      sectioNameToBackendVisitedSectioNameMapping[currentSectionName]
    if (this.props.visited_sections[visitedSectionModuleName] == 0) {
      this.props.markSectionVisited(visitedSectionModuleName)
    }
  }

  toggleLeftBar() {
    const { isLeftNavExpand, expandLeftNav } = this.props
    expandLeftNav(!isLeftNavExpand)
  }

  toggleRightBar() {
    const { isRightNavToggle, toggleRightNav } = this.props
    toggleRightNav(!isRightNavToggle)
  }

  fetchImageUrl(url) {
    if (_.isEmpty(url)) {
      return `${process.env.APP_BASE_URL}dist/images/profile-avatar.png`
    }
    return url
  }

  render() {
    const {
      location,
      fetchId,
      ui,
      has_api,
      has_pdf,
      has_resume,
      status,
      resumeSkillsInLinkedin,
      resumeSkillsNotInLinkedin,
      feedback,
      onSelectSection,
      onSelectPrev,
      onSelectNext,
      onSelectIndex,
      underlineSpellError,
      onUpdateText,
      unhighlightAll,
      activeNavIndex,
      resetSectionNavs,
      updateEditSection,
      editSectionUpdated,
      newSubSection,
      changeNewSubSectionValue,
      logModalMounted,
      editModalMounted,
      changeModalState,
      update_detailed_state,
      tourStatus,
      selectedPanelPersonalInfo,
      setSelectedPanelPersonalInfo,
      allCapsResume,
      allSmallResume,
      normalResume,
      tabIndex,
      user,
      isEditModal,
      activeEditModalSection,
      isLeftNavExpand,
      isRightNavToggle,
      suggestedSkills,
      show_log_modal,
      highlightEntityText,
      highlightableEditDivWords,
      unhighlightAllEdit,
      intl,
      aspireFeedbackData,
      customizations,
    } = this.props
    const currentSectionName = ui.section
    const CurrentComponent = this.sectionComponents[currentSectionName]
    const { totalScore, totalScoreColor, sectionWiseText, sectionWiseTextPdf } =
      ui

    const { community } = user

    let emptySections = []
    let sectionTextKey = {}

    if (has_pdf == '1') {
      sectionTextKey = {
        name: 'Personal Information',
        imageUrl: 'Profile Picture',
        headline: 'Headline',
        summary: 'Summary',
        experience: 'Experience',
        education: 'Education',
      }
    } else {
      sectionTextKey = {
        name: 'Personal Information',
        imageUrl: 'Profile Picture',
        headline: 'Headline',
        summary: 'Summary',
      }
    }

    for (let i in sectionTextKey) {
      if (sectionWiseText.hasOwnProperty(i) && _.isEmpty(sectionWiseText[i])) {
        emptySections.push(sectionTextKey[i])
      }
    }

    let summaryEmpty =
      _.isEmpty(ui['sectionWiseTextEditable']['summary']) ||
      ui['sectionWiseTextEditable']['summary']['0']['text'] == 'N/A'
    let loader = null

    if (isEditModal || show_log_modal) {
      loader = null
    } else {
      loader = <Loader padding={10} />
    }

    let score =
      aspireFeedbackData['summary_screen']['overall_total_score_class'][
        'overall_score'
      ]
    let color =
      aspireFeedbackData['summary_screen']['overall_total_score_class'][
        'color_feedback'
      ]
    score = parseFloat(score) / 100

    let selectedColor = null
    if (color === 'red') {
      selectedColor = '#f34d3d'
    } else if (color === 'yellow') {
      selectedColor = '#ff9e2d'
    } else if (color === 'green') {
      selectedColor = '#46a879'
    }

    var circularOptions = {
      color: selectedColor,
      pathColor: selectedColor,
      strokeWidth: 4,
      trailColor: '#f0f0f0',
      trailWidth: 2,
    }
    return (
      <div id="detailed-feedback">
        <div className="body-container">
          <div className="container-fluid tall">
            <AspireUiIntro />
            <Tour />
            {loader}
            <div className="row tall row-container detailed-feedback-container">
              <div
                className={`col-sm-8 padding-right0 tall feedback-container-left detailed-feedback-container-left ${
                  isRightNavToggle
                    ? 'panel-right-collapsed'
                    : 'panel-right-expand'
                }`}>
                <div
                  className={`tour-scroll js-detailed-feedback tall scroll-hidden vertical-scroll edit-pdf ${
                    isLeftNavExpand ? 'edit-pdf-collapsed' : 'edit-pdf-expand'
                  }`}
                  tabIndex="0"
                  role="region"
                  aria-label="Detailed Feedback Main Content">
                  <ProfileData
                    tabIndex={tabIndex + 10}
                    fetchId={fetchId}
                    totalScore={totalScore}
                    totalScoreColor={totalScoreColor}
                    sectionWiseText={sectionWiseText}
                    sectionWiseTextPdf={sectionWiseTextPdf}
                    currentSection={currentSectionName}
                    resumeSkillsInLinkedin={resumeSkillsInLinkedin}
                    resumeSkillsNotInLinkedin={resumeSkillsNotInLinkedin}
                    onSelectSection={onSelectSection}
                    onSelectPrev={onSelectPrev}
                    onSelectNext={onSelectNext}
                    onSelectIndex={onSelectIndex}
                    underlineSpellError={underlineSpellError}
                    ui={ui}
                    updateEditSection={updateEditSection}
                    editSectionUpdated={editSectionUpdated}
                    newSubSection={newSubSection}
                    changeNewSubSectionValue={changeNewSubSectionValue}
                    changeModalState={changeModalState}
                    selectedPanelPersonalInfo={selectedPanelPersonalInfo}
                    setSelectedPanelPersonalInfo={setSelectedPanelPersonalInfo}
                    highlightableEditDivWords={highlightableEditDivWords}
                  />
                </div>
              </div>
              {(
                <div className={`feedback-container-right ${
                      isRightNavToggle
                        ? 'feedback-container-right-collapsed'
                        : 'feedback-container-right-expand'
                    }`}>
                  <div
                    className={`col-sm-4 tall feedback-pdf-right js-detailed-feedback ${
                      isRightNavToggle
                        ? 'panel-right-collapsed'
                        : 'panel-right-expand'
                    }`}>
                    {currentSectionName !== 'Overall' ? (
                      <CurrentComponent
                        tabIndex={tabIndex + 1}
                        location={location}
                        ui={ui[currentSectionName]}
                        resumeSkillsInLinkedin={ui['resumeSkillsInLinkedin']}
                        resumeSkillsNotInLinkedin={
                          ui['resumeSkillsNotInLinkedin']
                        }
                        derivedSkills={ui['derivedSkills']}
                        sectionWiseTextEditable={
                          ui['sectionWiseTextEditable'][
                            sectionUnderscoreName[currentSectionName]
                          ]
                        }
                        sectionWiseTextStatic={
                          ui['sectionWiseTextStatic'][
                            sectionUnderscoreName[currentSectionName]
                          ]
                        }
                        suggestedSkills={suggestedSkills}
                        sectionWiseText={sectionWiseText}
                        sectionsPerSkill={ui['sectionsPerSkill']}
                        currentIndex={ui[currentSectionName]['currentIndex']}
                        currentSection={currentSectionName}
                        has_api={has_api}
                        has_pdf={has_pdf}
                        feedback={ui['sections'][currentSectionName]}
                        staticFeedback={
                          staticFeedback(intl)[currentSectionName]
                        }
                        onUpdateText={onUpdateText}
                        highlightEntityText={highlightEntityText}
                        unhighlightAll={unhighlightAll}
                        unhighlightAllEdit={unhighlightAllEdit}
                        activeNavIndex={activeNavIndex}
                        resetSectionNavs={resetSectionNavs}
                        update_detailed_state={update_detailed_state}
                        selectedPanelPersonalInfo={selectedPanelPersonalInfo}
                        setSelectedPanelPersonalInfo={
                          setSelectedPanelPersonalInfo
                        }
                        allCapsResume={allCapsResume}
                        allSmallResume={allSmallResume}
                        normalResume={normalResume}
                        newSubSection={newSubSection}
                        community={community}
                        onSelectIndex={onSelectIndex}
                        onSelectPrev={onSelectPrev}
                        onSelectNext={onSelectNext}
                        fetchId={fetchId}
                        onSelectSection={onSelectSection}
                      />
                    ) : (
                      <Overall
                        tabIndex={tabIndex + 1}
                        location={location}
                        currentSection={currentSectionName}
                        has_api={has_api}
                        has_pdf={has_pdf}
                        onSelectSection={onSelectSection}
                      />
                    )}
                  </div>
                  <div className="assistant-right-panel">
                    <div className="assistant-right-panel-topbar">
                      <div className="assistant-main-heading">
                        <FormattedMessage
                          id="aspire.rightNav.aiAssistant"
                          defaultMessage="AI Assistant"
                        />
                      </div>
                      <button
                        className={`right-nav-toggle-btn ${
                          isRightNavToggle ? 'active' : ''
                        }`}
                        onClick={() => this.toggleRightBar()}>
                        <img
                          className={`right-nav-toggle-icon ${
                            isRightNavToggle ? 'active' : ''
                          }`}
                          alt="click here to close the issues menu"
                          src={`${process.env.APP_BASE_URL}dist/images/menu-expand.svg`}
                        />
                      </button>
                    </div>
                    <div
                      className={classNames(
                        'assistant-right-panel-profile-strength',
                        {
                          active: this.state.activeId === 1,
                        }
                      )}
                      style={
                        customizations.is_navigation_enabled
                          ? { marginRight: '37px' }
                          : {}
                      }
                      onClick={() => this.setState({ activeId: 1 })}>
                      <div className="profile-picture-container">
                        <div className="profile-picture-heading">
                          <FormattedMessage
                            id="aspire.leftNav.profileStrengthHeading"
                            defaultMessage="Profile Strength"
                          />
                        </div>
                        <div className="profile-picture-content">
                          <div className="profile-picture-score-container">
                            <CircularBar
                              value={score * 100}
                              strokeWidth={3}
                              styles={circularOptions}
                              className="profile-picture-circular-bar"
                            />
                            <img
                              className="rounded-circle p-image assistant-right-panel-profile-picture"
                              alt="profile-picture"
                              src={this.fetchImageUrl(
                                sectionWiseText['imageUrl']
                              )}
                            />
                          </div>
                          <div
                            className={`profile-picture-text profile-picture-text-status-${color}`}>
                            {this.textMap[color]}
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      // assistant right panel to be added in future
                      /* <div
                        className={classNames(
                          'assistant-right-panel-coach-review',
                          {
                            active: this.state.activeId === 2,
                          }
                        )}
                        onClick={() => this.setState({ activeId: 2 })}>
                        <div className="assistant-right-panel-coach-review-heading">
                          Coach Review
                        </div>
                        <div className="assistant-right-panel-coach-review-content">
                          No Suggestion
                        </div>
                      </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <PageTracking product="aspire" id={fetchId} page="detailed_feedback" />
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    visited_sections: state.aspireFeedbackData.visited_sections,
    user: state.user.data,
    isEditModal: state.editData.show_edit_modal,
    activeEditModalSection: state.editData.active_edit_modal_section,
    isLeftNavExpand: state.editData.isLeftNavExpand,
    isRightNavToggle: state.editData.isRightNavToggle,
    show_log_modal: state.editData.show_log_modal,
    aspireFeedbackData: state.aspireFeedbackData.data,
    customizations: state.userCustomizations.data,
  }
}

export default connect(mapStateToProps, {
  markSectionVisited,
  expandLeftNav,
  toggleRightNav,
  selectIndex,
  showEditModal,
})(injectIntl(DetailedFeedback))
